import api from "./api";

// Mantenimiento del personal: terapeutas, secretarias, personal de limpieza,
// director, coordinador, etc.
const trabajadorService = {
    getsTrabajadorResumenView: async (filters) => {
        const response = await api.get("/Trabajador/GetsTrabajadorResumenView", { params: filters });

        return response.data.data;
    },

    getTrabajadorView: async (idTrabajador) => {
        const response = await api.get("/Trabajador/GetTrabajadorView", { params: { idTrabajador } });

        return response.data.data;
    },

    getsTerapeutas: async (name = "", soloActivos = true, todos = false, idFilial = 0) => {
        const response = await api.get("/Trabajador/GetsTerapeutas", {
            params: { name, soloActivos, todos, idFilial }
        });

        return response.data.data;
    },

    addUpdateTrabajador: async (trabajador) => {
        const response = await api.post("/Trabajador/AddUpdateTrabajador", trabajador);

        return response.data.data;
    },

    annulTrabajador: async (idTrabajador) => {
        const response = await api.post("/Trabajador/AnnulTrabajador?idTrabajador=" + idTrabajador);

        return response.data.data;
    },

    activeTrabajador: async (idTrabajador) => {
        const response = await api.post("/Trabajador/ActiveTrabajador?idTrabajador=" + idTrabajador);

        return response.data.data;
    },
};

export const getsTrabajadorResumenView = trabajadorService.getsTrabajadorResumenView;
export const getsTrabajador = trabajadorService.getsTrabajadorResumenView;
export const getTrabajadorView = trabajadorService.getTrabajadorView;
export const getsTerapeutas = trabajadorService.getsTerapeutas;
export const addUpdateTrabajador = trabajadorService.addUpdateTrabajador;
export const annulTrabajador = trabajadorService.annulTrabajador;
export const activeTrabajador = trabajadorService.activeTrabajador;

export default trabajadorService;
